import React, { useEffect } from 'react';

import { BannerProvider } from '../../contexts/BannerContext';
import ErrorBoundary from '../../contexts/ErrorBoundary';

export const SurveyFeedback = () => {

  useEffect(() => {
    const handleResize = () => {
      let containerWidth = document.getElementById('epcfeedbackContainer').offsetWidth;
      let compSize = 0.8;
      const compSizeWidth = (containerWidth * compSize) + 'px';
      const centerStyle = '0 auto';
      document.querySelector('#epcfeedback > div').style.width = compSizeWidth;
      document.querySelector('#epcfeedback > div > div').style.width = compSizeWidth;
      document.querySelector('#epcfeedback > div > div > div').style.width = compSizeWidth;
      document.querySelector('#epcfeedback > div > div > div > div').style.width = compSizeWidth;
      document.querySelector('.QSIUserDefinedHTML').style.margin = centerStyle;
    };

    const observer = new MutationObserver(handleResize);
    const survey = document.getElementById('epcfeedback');
    const options = { attributes: false, childList: true, subtree: false };
    observer.observe(survey, options);
    window.addEventListener('resize', handleResize);
    return () => {
      window.removeEventListener('resize', handleResize);
      observer.disconnect();
    };
  }, []);

  return (
    <ErrorBoundary>
      <BannerProvider>
        <div id="epcfeedbackContainer" className="sui-pt-8 sui-overflow-hidden sui-text-center">
          <div id="epcfeedback" className="sui-z-0 sui-relative !sui-max-w-full" data-testid="feedbackTest" />
        </div>
      </BannerProvider>
    </ErrorBoundary>
  );
};

export default SurveyFeedback;
